<template>
  <div class="row">
    <el-row type="flex" class="row-bg" justify="space-around">
      <el-col :span="21">
        <div class="grid-content bg-purple">
          <h1 style="margin: 0;">
            Locations
          </h1>
        </div>
      </el-col>
      <el-col :span="2">
        <div class="grid-content" v-if="!error" />
        <p-button
          type="default"
          size="lg"
          icon
          round
          @click="handleNewLocation()"
        >
          <i class="nc-icon nc-simple-add" />
        </p-button>
      </el-col>
    </el-row>
    <div class="col-md-12 card">
      <div class="card-body row">
        <div class="col-sm-3">
          <el-select
            class="select-default"
            v-model="pagination.perPage"
            placeholder="Per page"
          >
            <el-option
              class="select-default"
              v-for="item in pagination.perPageOptions"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </div>
        <div class="col-sm-6">
          <p-button
            round
            @click="exportBSALocations()"
            v-if="isOneOfTheseRoles(['admin'])"
          >
            <i class="fas fa-file-export" />  Export BSA Locations
          </p-button>
        </div>
        <div class="col-sm-3">
          <div class="pull-right">
            <fg-input
              class="input-sm"
              placeholder="Search"
              @keyup.enter="getLocations"
              v-model="searchQuery"
              addon-right-icon="nc-icon nc-zoom-split"
            />
          </div>
        </div>
        <div class="col-sm-12 mt-2">
          <el-table
            class="table-striped"
            :data="tableData"
            border
            style="width: 100%"
          >
            <el-table-column
              v-for="column in tableColumns"
              :key="column.label"
              :min-width="column.minWidth"
              :prop="column.prop"
              :label="column.label"
            />
            <el-table-column
              :min-width="50"
              class-name="td-actions text-center"
              label="Edit"
            >
              <template slot-scope="props">
                <p-button
                  type="success"
                  size="sm"
                  icon
                  @click="handleEdit(props.$index, props.row)"
                >
                  <i class="fa fa-edit" />
                </p-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="col-sm-6 pagination-info">
          <p class="category">
            Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
          </p>
        </div>
        <div class="col-sm-6">
          <p-pagination
            class="pull-right"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @input="handlePageChanged"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import {
    mapState, mapActions, vuex, mapGetters
} from 'vuex';

import {
    Table, TableColumn, Select, Option
} from 'element-ui';
import Pagination from '../../components/UIComponents/Pagination';
import { RepositoryFactory } from '../../repositories/repositoryFactory';
import apiService from '../../repositories/apiService';

const LocationsRepository = RepositoryFactory.get('locations');
const data = 'Locations';

Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
export default {
    components: {
        [Pagination.name]: Pagination
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to);
        },
        to() {
            let highBound = this.from + this.pagination.perPage;
            if (this.total < highBound) {
                highBound = this.total;
            }
            return highBound;
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1);
        },
        total() {
            return this.pagination.total;
        }
    },
    data() {
        return {
            pagination: {
                perPage: 20,
                currentPage: 1,
                perPageOptions: [20, 50, 100],
                total: 0
            },
            error: '',
            searchQuery: '',
            propsToSearch: ['name', 'email', 'age'],
            tableColumns: [
                {
                    prop: 'id',
                    label: 'ID',
                    minWidth: 75
                },
                {
                    prop: 'name',
                    label: 'Name',
                    minWidth: 250
                },
                {
                    prop: 'parent_name',
                    label: 'Parent Location',
                    minWidth: 200
                }
            ],
            tableData: []
        };
    },
    methods: {
        handleEdit(index, row) {
            this.$router.push({ name: 'LocationEdit', params: { id: row.id } });
        },
        handleDelete(index, row) {
            const indexToDelete = this.tableData.findIndex((tableRow) => tableRow.id === row.id);
            if (indexToDelete >= 0) {
                this.tableData.splice(indexToDelete, 1);
            }
        },
        getLocations() {
            LocationsRepository.getLocations(this.pagination.currentPage, this.pagination.perPage, this.searchQuery)
                .then((response) => {
                    this.tableData = response.data.data;
                    this.pagination.total = response.data.total;
                })
                .catch((error) => {
                    this.error = error.response.data.message;
                });
        },
        handlePageChanged(newPage) {
            this.pagination.currentPage = newPage;
            this.getLocations();
        },
        handleNewLocation() {
            this.$router.push({ name: 'LocationCreate' });
        },
        exportBSALocations() {
            apiService
                .get('/get-BSA-locations/')
                .then((response) => {
                    let csv = 'ID, Name\n';
                    response.data.forEach((row) => {
                        csv += `${row.id},`;
                        csv += `${row.name},`;
                        csv += '\n';
                    });
                    const anchor = document.createElement('a');
                    anchor.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csv)}`;
                    anchor.target = '_blank';
                    anchor.download = 'BSALocations.csv';
                    anchor.click();
                }).catch((error) => {
                    this.error = error.response.data.message;
                    this.$message(this.error);
                });
        }
    },
    created() {
        this.getLocations();
    },
};
</script>
<style lang="scss">
  .el-table .td-actions{
  button.btn {
    margin-right: 5px;
  }
  }
</style>
